<template>
  <section class="payment">
    <p>
      本订阅协议是您与格隆汇所属的深圳格隆汇信息科技有限公司(以下简称格隆汇/我们)之间达成的协议。本协议自我们确认您的订购之日起/您的订购续签之日起生效。
    </p>
    <h1>一、订购</h1>
    <p>
      1、成功订阅格隆汇付费文章/栏目（目前栏目订阅只在安卓平台上提供）/会员/课程内容，即表示您同意并愿意遵守本订阅协议。
      <br />2、订阅价格不含任何税款。您必须支付依据本协议产生的、并且是适用法律允许我们向您收取的任何适用的增值税、销售税、其他交易税费、收费或附加费其他法律规定的附加费或类似费用。
      <br />3、订阅成功后，我们授予您访问和使用您所订购的格隆汇付费内容，并安装和使用订购附带软件的权利，本协议中提供相关的详细说明。我们保留所有其他权利。
      <br />4、您对产品及内容的使用必须遵循本协议。您不得对产品进行反向工程、反向编译、反汇编或绕过产品技术限制。对于计量您对订阅服务使用情况的任何计费机制，您不得禁用、篡改或以其他方式尝试规避。
      <br />5、您不得将订阅内容其中的任何部分出租、租赁、出借、转售、转让或托管给第三方，不得明示或默示给任何第三人使用，不得再次销售订阅内容，不得以任何收费或免费的方式公开传播订阅内容。
      <br />6、、您必须负责维护与使用当月服务相关的任何非公开身份验证凭证的保密性。如有任何可能的账户或身份验证凭据的误用或任何与在线服务有关的安全意外行为，您必须立刻通知我们的客户支持团队。因您主动泄露身份验证凭证导致账户丢失的，由您承担相应后果。
    </p>
    <h1>二、期限、终止与暂停</h1>
    <p>
      1、期限。本协议在您的订购到期、终止或续签(以时间较早者为准)之前仍然有效。您应当注意，订阅栏目/会员的有效期规格共分四个，其中一个月为31天，3个月为93天(31*3)，6个月为186天(31*6)，全年固定为366天。
      <br />2、续订，当栏目/会员订阅到期后您将无法查看该栏目/会员的付费内容（包括历史文章），您可以选择续订。
      <br />3、订阅为自愿行为，且订阅内容为特殊内容，您的订阅一经付款即为生效，孰不退款、不退格隆贝/余额，不能转换其他作者。
    </p>
    <h1>三、免责声明</h1>
    <p>
      1、您理解并同意，我们的订阅内容不做出任何明示或默示保证，所有内容仅供参考，您已知晓投资风险并愿意自行承担。
    </p>
    <h1>四、违约责任</h1>
    <p>
      1、、如果出现下述一种或多种情况，则我们可在不通知的情况下暂停您对在线服务的使用或终止您的订购并回收您的帐户：
      <br />&nbsp;&nbsp;1-1、您没有依照本协议支付应付款项
      <br />&nbsp;&nbsp;1-2、您未经我们书面许可擅自使用了我们的商标或其他标识、享有著作权的内容、及其他属于我们的权利
      <br />&nbsp;&nbsp;1-3、您没有遵守使用方式政策或违反了本协议的其他条款。
    </p>
    <h1>五、其他</h1>
    <p>
      1、可分割性。如果本协议的任何部分被认定不可执行，其余内容仍然具备完全效力。
      <br />2、本协议中所表述的。“日”、“天”均指日历日。
      <br />3、我们拥有本协议的最终解释权.
      <br />4、对本协议产生纠纷的，提交深圳市南山区人民法院诉讼解决。
    </p>
  </section>
</template>

<script>
// import axios from "axios"
export default {
  name: "rule",
  data() {
    return {
      val: ""
    };
  },

  created() {
    window.location.replace(
      "https://hybrid.gelonghui.com/description/pay-attention"
    );
  },
  mounted() {
    document.title = "付费须知协议";
  }
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
}

.payment {
  position: relative;
  padding: 40px;
  max-width: 750px;
  width: 100%;
  text-align: left;
  // background-color: #282C37;
  background: #ffffff;

  p {
    margin-top: 20px;
    font-size: 26px;
    letter-spacing: 2px;
    color: rgba(102, 102, 102, 1);
    line-height: 38px;
  }
  h1 {
    margin-top: 20px;
    font-size: 30px;
    color: rgba(51, 51, 51, 1);
    line-height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/member-share/payAgreement.vue